import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    mfgpartnumberlabel = "mfgpartnumberlabel",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.mfgpartnumberlabel]: string;
    };
}

type Props = WidgetProps & HasProduct;

export interface ProductDetailsManufacturingPartNumberStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
    fitContent?: InjectableCss;
}

export const manufacturingPartNumberStyles: ProductDetailsManufacturingPartNumberStyles = {
    labelText: {
        size: 14,
        weight: "bold",
        css: css`
            margin-right: .18750625rem;
            white-space: nowrap;
        `,
    },
    valueText: {
        size: 14,
        css: css`
            margin-bottom: .31250625rem;
        `,
    },
    fitContent: {
        css: css`
        width: fit-content;
        float:left;
        margin-bottom:1.5rem;
         }
        `,
    },
};

const styles = manufacturingPartNumberStyles;

const ProductDetailsManufacturingPartNumber: React.FC<Props> = ({ fields, product }) => {
    if (!product.manufacturerItem) {
        return null;
    }
    return (
        <Typography {...styles.valueText} {...styles.fitContent} as="p">
            <Typography {...styles.labelText}>
                {translate(fields.mfgpartnumberlabel) || translate("MFG:")}
            </Typography>
            {product.manufacturerItem}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsManufacturingPartNumber),
    definition: {
        displayName: "Manufacturing Part Number",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.mfgpartnumberlabel,
                editorTemplate: "TextField",
                defaultValue: " MFG:",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
